import React, { useEffect, useMemo, useState, useRef } from 'react'
import { Button } from 'antd'
import ProgramCard from 'components/ProgramCard'

const MultipleProgramContent = ({
  i18n,
  theme,
  onNext,
  index,
  isLast,
  themeSize,
  selectedPrograms,
  sku,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null)
  const [allPrograms, setAllPrograms] = useState([])
  const selectedProgramRef = useRef(null)

  const programs = useMemo(() => {
    if (!theme?.programs) return []
    let programs = theme.programs.map((program) => {
      return {
        ...program,
        themeId: theme.subCategoryId,
      }
    })

    return programs.sort((a, b) => {
      if (a.sort === 1 && b.sort !== 1) return -1
      if (b.sort === 1 && a.sort !== 1) return 1
      return 0
    })
  }, [theme])

  useEffect(() => {
    if (programs.length > 0) {
      const selectedProgram =
        selectedPrograms.find((selectedProgram) =>
          programs.find(
            (program) =>
              program.id === selectedProgram.id &&
              program.themeId === selectedProgram.themeId
          )
        ) ||
        programs.find((program) => program.sort === 1) ||
        programs[0]
      setAllPrograms(programs)
      setSelectedProgram(selectedProgram)
    }
  }, [programs, selectedPrograms])

  useEffect(() => {
    if (selectedProgram && selectedProgramRef.current) {
      setTimeout(() => {
        selectedProgramRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        })
      }, 100)
    }
  }, [selectedProgram])

  return (
    <div className='content-container'>
      <img
        className='program-card'
        key={selectedProgram?.coverUrl}
        src={selectedProgram?.coverUrl}
        alt='program-card'
      />
      <div className='title'>
        {i18n(
          `Your recommended {0} care program`,
          theme.subCategoryName?.toLowerCase()
        )}
      </div>
      <div className='program-description'>{selectedProgram?.description}</div>
      {allPrograms.length > 1 && (
        <>
          <div className='program-others'>
            {themeSize === 1
              ? i18n('Or you can switch to another program')
              : i18n('Or select another program')}
          </div>
          <div className='program-others-list-container'>
            <div className='program-others-list'>
              {allPrograms.map((program, index) => (
                <div
                  key={index}
                  ref={
                    selectedProgram?.id === program.id
                      ? selectedProgramRef
                      : null
                  }
                >
                  <ProgramCard
                    program={program}
                    onClick={() => setSelectedProgram(program)}
                    selected={selectedProgram?.id === program.id}
                  />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      <Button
        className='btn-primary full-width-btn button-start'
        onClick={() => onNext(index, selectedProgram)}
      >
        {isLast ? i18n('Get Started') : i18n('Next')}
      </Button>
      <div className='bottom-tips'>
        {sku === 'mca' ? (
          <>
            {i18n(
              'This program is intended to support your wellness and does not replace advice from healthcare providers. If you experience a medical emergency or severe symptoms, call 911 or seek immediate medical attention.'
            )}
          </>
        ) : (
          <>
            {i18n(
              `By clicking ‘Start Program’, you acknowledge you are located in a US state in which FitOn Care is authorized to operate ({0}) and accept responsibility for any co-pay, deductible, coinsurance, or other out-of-pocket costs if the program is not fully covered by your health insurance plan.`,
              <a
                href='https://fitoncare.com/am-i-covered'
                target='_blank'
                rel='noreferrer'
                className='gradient-font-1'
              >
                {i18n('here')}
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default MultipleProgramContent
